module.exports = __webpack_public_path__ + "86a3a73c0164a7d0997dbfecc8067b6e.svg";